import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

import AlxSelect from '../alx-components/select';
import { RootState } from '../../store/rootReducer';
import storageService from '../../services/storage.service';
import { INSURANCE_COMPANIES } from '../../constants';
import { Language, getSupportedLanguages } from '../../constants';
import { images } from '../../assets/images/images';
import { BrandHeaderStyle } from './brand-header-style';

const defaultLogo = (
  <div className="welcome welcome--active">
    <img src={images.logo} alt="Asitur logo" />
  </div>
);

const BrandHeader = () => {
  const { t, i18n } = useTranslation(['common', 'auth', 'assistance']);
  const providerCodeState = useSelector((state: RootState) => state.general.provider);
  const providerCodeStorage = storageService.getLocalItem<string>('providerCode');
  const supportedLanguages = getSupportedLanguages(
    t,
    providerCodeState ? providerCodeState : providerCodeStorage ? providerCodeStorage : undefined,
  );

  const logo = useMemo(() => {
    if (providerCodeState && INSURANCE_COMPANIES?.[providerCodeState]) {
      return (
        <img src={INSURANCE_COMPANIES?.[providerCodeState]?.img} alt={INSURANCE_COMPANIES?.[providerCodeState]?.alt} />
      );
    } else if (providerCodeStorage && INSURANCE_COMPANIES?.[providerCodeStorage]) {
      return (
        <img
          src={INSURANCE_COMPANIES?.[providerCodeStorage]?.img}
          alt={INSURANCE_COMPANIES?.[providerCodeStorage]?.alt}
        />
      );
    }
    return defaultLogo;
  }, [providerCodeState, providerCodeStorage]);

  return (
    <BrandHeaderStyle id="brand-header">
      <div className="language-picker-wrapper">
        <AlxSelect
          variant="filled"
          mini="true"
          containerclassname="language-picker"
          value={supportedLanguages?.[i18n.language as Language]?.value}
          onChange={(newValue) => {
            i18n.changeLanguage(newValue.target.value as Language);
            // pushDataLayerEvent('cambio_idioma', { idioma: newValue.target.value }, 'iniciar-sesion');
          }}
          options={Object.values(supportedLanguages)}
        />
      </div>

      <div className="brand-header-logo">{logo}</div>
    </BrandHeaderStyle>
  );
};

export default BrandHeader;
